/** @jsxImportSource @emotion/react */
import { Button } from '@/components/button';
import { css } from '@emotion/react';
import { Typography } from 'antd';
import { FallbackProps } from 'react-error-boundary';
import { RedoOutlined } from '@ant-design/icons';

export function ErrorPage({ error, resetErrorBoundary }: FallbackProps) {
  console.error({ error });
  return (
    <div css={rootStyles}>
      <Typography.Text type='danger'>
        Lỗi hệ thống vui lòng thử lại bằng cách nhấn vào nút "Tải lại trang".
      </Typography.Text>
      <Button
        type='primary'
        onClick={() => {
          resetErrorBoundary();
          window.location.reload();
        }}
        icon={<RedoOutlined />}
        iconPosition='end'
      >
        Tải lại trang
      </Button>
    </div>
  );
}

const rootStyles = css`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 2rem;
`;
